const Loading = function () {
  return <div className='loader'></div>;
};

export default Loading;
